// extracted by mini-css-extract-plugin
export default {"container":"healthmonitoringmaxvalues_container__rFhxT","item_right":"healthmonitoringmaxvalues_item_right__f1-2N","border":"healthmonitoringmaxvalues_border__V9B0b"};